import { Badge, Flex, Text } from '@mantine/core';
import React from 'react';
import { TooltipBox } from './TooltipBox.tsx';

interface Props {
	countSummaryItems: string[];
}

export const FooterStatAllocations = ({ countSummaryItems }: Props) => {
	if (!countSummaryItems.length) {
		return null;
	}

	const firstItem = countSummaryItems[0];
	const remainingItems = countSummaryItems.slice(1);
	const count = remainingItems.length;

	return (
		<Flex align="center" gap="0.25rem" w="100%">
			<Flex align="center" gap="0.25rem">
				<Text fw={600} truncate lineClamp={1} style={{ flex: 1 }}>
					{firstItem}
				</Text>
				{count > 0 && (
					<TooltipBox
						label={
							<Flex direction="column" gap="0.25rem" p="0.25rem">
								{remainingItems.map((item, index) => (
									<Text key={index} fz="md" fw={600} c="dark.9">
										{item}
									</Text>
								))}
							</Flex>
						}
					>
						<Badge bg="gray.4" c="dark.4" fw={600} size="sm">
							+{count}
						</Badge>
					</TooltipBox>
				)}
			</Flex>
		</Flex>
	);
};
